import { SubscriptionTypeEnum } from '../types/Enums';

/**
 * Check if subscription type is basic
 *
 * @param subsriptionType - subscription type
 * @returns True if subscription type is basic, false otherwise
 */
export function isSubscriptionTypeBasic(subsriptionType: string) {
  return subsriptionType === SubscriptionTypeEnum.BASIC ? true : false;
}

/**
 *  Check if subscription type is pro
 *
 * @param subsriptionType - subscription type
 * @returns True if subscription type is pro, false otherwise
 */
export function isSubscriptionTypePro(subsriptionType: string) {
  return subsriptionType === SubscriptionTypeEnum.PRO ? true : false;
}

/**
 * Check if subscription type is elite
 *
 * @param subsriptionType - subscription type
 * @returns True if subscription type is elite, false otherwise
 */
export function isSubscriptionTypeElite(subsriptionType: string) {
  return subsriptionType === SubscriptionTypeEnum.ELITE ? true : false;
}